import React from 'react';
import Parser, { domToReact, Element, HTMLReactParserOptions } from 'html-react-parser';
import Script from 'next/script';

import { LOGGER } from '@amzn/monera-app-core';
import { HtmlWidgetProps } from '@amzn/monera-app-core-components/lib/components/html-widget/types';

import { StyledHtmlWidgetContainer } from './styles';

/**
 * Device Subscriptions version of ServerRenderedHtmlParserWidget that preserves all script attributes
 * This component fixes an issue where script tags with attributes like type="a-state" and data-a-state
 * weren't properly preserved when converting to Next.js Script components
 */
export const DeviceSubsServerRenderedHtmlWidget = (props: HtmlWidgetProps) => {
  const { html = '', isDangerousHtml = false, ...rest } = props;
  if (!html) {
    return null;
  }
  const options: HTMLReactParserOptions = {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    replace(domNode) {
      if (domNode instanceof Element && domNode.attribs && domNode.type === 'script') {
        // Pass all attributes to preserve things like type="a-state" and data-a-state
        return <Script {...domNode.attribs}>{domToReact(domNode.childNodes)}</Script>;
      }
    }
  };
  const content = Parser(html, options);
  if (!isDangerousHtml) {
    LOGGER.info(
      'If you do not see HTML content rendered, please set the isDangerousHTML prop to true such that you acknowledge the risk of rendering non-sanitised HTML content'
    );
  }
  return isDangerousHtml ? (
    <StyledHtmlWidgetContainer data-cy={'html-widget-container'} {...rest}>
      <>{content}</>
    </StyledHtmlWidgetContainer>
  ) : null;
};
